import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
export function CasinoSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-5%', '5%']);
  return <section ref={ref} className="py-32 px-4 w-full bg-gray-50 relative overflow-hidden" data-id="element-97">
      {/* Neon Purple Glows */}
      <div className="absolute top-1/2 left-0 w-full h-[500px] bg-neon-purple/5 blur-[150px] -translate-y-1/2 pointer-events-none" data-id="element-98" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative aspect-video lg:aspect-square rounded-[2.5rem] overflow-hidden group" data-id="element-100">
          {/* Animated Border Glow */}
          <div className="absolute inset-0 rounded-[2.5rem] border-2 border-neon-purple/20 group-hover:border-neon-purple/60 transition-colors duration-500 z-20" data-id="element-101" />
          <div className="absolute inset-0 rounded-[2.5rem] shadow-[0_0_50px_rgba(168,85,247,0.1)] group-hover:shadow-[0_0_80px_rgba(168,85,247,0.25)] transition-shadow duration-500 z-20 pointer-events-none" data-id="element-102" />

          {/* Stock Image with Parallax */}
          <motion.div style={{
          y
        }} className="absolute -inset-10 z-10" data-id="element-103">
            <img src="https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=900&q=80" alt="Las Vegas Casino am Euro Rastpark Himmelkron" className="w-full h-full object-cover" data-id="element-104" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20" data-id="element-105" />
            <div className="absolute inset-0 bg-neon-purple/5 mix-blend-overlay" data-id="element-106" />
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col items-start" data-id="element-107">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-neon-purple" data-id="element-108">
            Las Vegas feeling –<br data-id="element-109" />
            mitten in Bayern
          </h2>
          <p className="text-xl text-gray-500 mb-10 font-body leading-relaxed" data-id="element-110">
            Tauchen Sie ein in eine Welt voller Spannung und Entertainment.
            Unser Casino bietet modernste Automaten, exklusives Ambiente und den
            perfekten Ausgleich nach einer langen Fahrt.
          </p>
          <motion.div whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(168, 85, 247, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} className="inline-block rounded-xl" data-id="element-111">
            <Link to="/casino" className="inline-block px-8 py-4 rounded-xl bg-neon-purple text-white font-semibold text-lg transition-colors" data-id="element-112">
              Mehr erfahren
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}